import React, { useState } from "react";
import { CheckCircle2, Loader2, Send } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function RequestNewCode({ code }: { code: string }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", phone: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [sentTo, setSentTo] = useState<string | null>(null);
  const set = (k: string) => (e: any) => setF({ ...f, [k]: e.target.value });
  const send = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/public/code/request-new", { ...f, code, lang: localStorage.getItem("irs_lang") === "es" ? "es" : "en" });
      setSentTo(data.org_name || "your organization");
    } catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  };
  if (sentTo !== null) {
    return (
      <div className="mt-4 flex items-start gap-3 rounded-xl bg-[#DCFCE7] px-4 py-3 text-[15px] text-[#166534]" data-testid="new-code-sent">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0" />
        <span>Your request was sent to <b>{sentTo}</b>. They will email you a new code. We also emailed you a confirmation.</span>
      </div>
    );
  }
  if (!open) {
    return <button type="button" className="btn-secondary mt-3 h-12 w-full text-base" onClick={() => setOpen(true)} data-testid="request-new-code-button"><Send className="h-4 w-4" /> Request a new code</button>;
  }
  return (
    <div className="mt-4 space-y-3 rounded-xl border border-[#E2E8F0] bg-white p-4" data-testid="request-new-code-form">
      <p className="text-sm text-[#475569]">We'll email your organization and ask them to send you a new code.</p>
      <input className="field-input" placeholder="Your full name" value={f.name} onChange={set("name")} data-testid="new-code-name" />
      <input className="field-input" type="email" placeholder="Your email" value={f.email} onChange={set("email")} data-testid="new-code-email" />
      <input className="field-input" placeholder="Phone (optional)" value={f.phone} onChange={set("phone")} data-testid="new-code-phone" />
      <textarea className="field-input min-h-[80px] py-2" placeholder="Message (optional)" value={f.note} onChange={set("note")} maxLength={1000} data-testid="new-code-note" />
      {err && <p className="text-sm text-[#991B1B]" data-testid="new-code-error">{err}</p>}
      <button type="button" className="btn-primary h-12 w-full" disabled={busy || f.name.trim().length < 2 || !f.email.includes("@")} onClick={send} data-testid="new-code-send">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Send className="h-4 w-4" /> Send request</>}
      </button>
    </div>
  );
}
